import { mapCategoryToHr, mapModuleToHr } from "../../../LanguageMapper";
import {
  PageRoute,
  QueryParam
} from "../../../../models/enums";
import {
  stringifyURI,
} from "../../../../services/utils";

// One selected multi level value, as a chain of nodes from the top level down
// (e.g. [make, model] or [lv1, lv2]); each entry knows the search field of its level.
export interface MultiLevelChainValueI {
  field: string;
  value: { id: string; name: string; route?: string };
}

// Breadcrumb links for the selected multi level values (make/model, subcategories).
// `parsedValues` holds one chain per selected value; chains whose fields are all
// covered by another selected chain are dropped.
export const generateMultiLevelRouteLink = (
  parsedValues: MultiLevelChainValueI[][],
  routeLinks,
  module,
  queryParams
) => {
  if (!module) {
    return routeLinks;
  }

  let generatedRouteLinks = routeLinks

  let reducedValues = parsedValues;

  for (let i = parsedValues.length - 1; i >= 0; i -= 1) {
    if (reducedValues.length === 0) {
      break;
    }

    const element = parsedValues[i];

    for (let j = 0; j < element.length; j += 1) {
      reducedValues = reducedValues.filter(
        value =>
          element === value ||
          value.every(x => x.field !== element[j].field)
      );
    }
  }

  reducedValues.forEach(chain => {
    // one link per level of the chain; the slug path of a level is built from
    // the routes of its ancestors and itself (make -> "bmw", model -> "bmw/x5")
    chain.forEach((v, index) => {
      if (!v || !v.value) {
        return;
      }

      const searchQuery = {
        // @ts-ignore
        module: queryParams.current.module,
        category: queryParams.current.category,
        [v.field]: [v.value.id]
      };

      const multiLevelRoute = chain
        .slice(0, index + 1)
        .map(level => level.value && level.value.route)
        .filter(Boolean)
        .join("/");

      generatedRouteLinks = generatedRouteLinks.concat({
        field: v.field,
        title: v.value.name,
        link: `/${mapModuleToHr(queryParams.current.module)}/${mapCategoryToHr(
          queryParams.current.category,
          mapModuleToHr(module)
        )}${multiLevelRoute ? `/${multiLevelRoute}` : ""}${PageRoute.search}${stringifyURI(searchQuery, QueryParam.searchQuery)}`
      });
    });
  });

  return generatedRouteLinks
};



// WEBPACK FOOTER //
// ./src/routes/Search/HOCs/utils/generateMultiLevelRouteLink.ts